import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppFooter } from "@/components/AppFooter";
import { AppHeader } from "@/components/AppHeader";
import { AuthCallback } from "@/components/auth/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ComplaintPage from "@/pages/ComplaintPage";
import LoginPage from "@/pages/LoginPage";
import MyComplaintDetailPage from "@/pages/MyComplaintDetailPage";
import MyComplaintsPage from "@/pages/MyComplaintsPage";
import RegisterPage from "@/pages/RegisterPage";
import TrackPage from "@/pages/TrackPage";

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<ComplaintPage />} />
      <Route path="/masuk" element={<LoginPage />} />
      <Route path="/daftar" element={<RegisterPage />} />
      <Route path="/lacak" element={<TrackPage />} />
      <Route path="/pengaduan-saya" element={<ProtectedRoute role="warga"><MyComplaintsPage /></ProtectedRoute>} />
      <Route path="/pengaduan-saya/:id" element={<ProtectedRoute role="warga"><MyComplaintDetailPage /></ProtectedRoute>} />
      <Route path="/admin/login" element={<Navigate to="/masuk" replace />} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboardPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="flex min-h-screen flex-col bg-[#F5F8F7]">
          <AppHeader />
          <div className="flex-1">
            <AppRoutes />
          </div>
          <AppFooter />
        </div>
        <Toaster position="top-center" richColors closeButton theme="light" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
